/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Recorder_TitleInputs */



/**
* | output |
* | --- |
* | "Audio Recorder" |
*
* @param {Audio_Recorder_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_title = /** @type {((inputs?: Audio_Recorder_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistreur audio")
	if (locale === "de") return /** @type {LocalizedString} */ ("Audiorecorder")
	if (locale === "it") return /** @type {LocalizedString} */ ("Registratore audio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Аудиозапись")
	if (locale === "es") return /** @type {LocalizedString} */ ("Grabadora de audio")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("录音机")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オーディオレコーダー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑडियो रिकॉर्डर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Gravador de áudio")
	return /** @type {LocalizedString} */ ("Audio Recorder")
});